import { render, staticRenderFns } from "./HelpfulInfo.vue?vue&type=template&id=44e449c2&scoped=true"
import script from "./HelpfulInfo.vue?vue&type=script&lang=js"
export * from "./HelpfulInfo.vue?vue&type=script&lang=js"
import style0 from "./HelpfulInfo.vue?vue&type=style&index=0&id=44e449c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e449c2",
  null
  
)

export default component.exports